import { createTheme, MantineProvider, PasswordInput, TextInput, useMantineColorScheme } from "@mantine/core";
import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";
import { useEffect } from "react";

import logoPB from "@/assets/images/logo-dark-1_a.svg";
import { useWindowLocationHost } from "@/hooks";
import { MODAL_HANDLER } from "@/lib/Mantine";
import { useGetCompanyByHostQuery } from "@/store";

const sitekey = import.meta.env.VITE_RECAPTCHA_KEY || "key_here";
export const Route = createFileRoute("/_auth")({
  component: RouteComponent,
  beforeLoad: ({ matches, context }) => {
    const {
      auth: { token }
    } = context.store.getState();
    const matchLogin = matches.find((match) => match.routeId === "/_auth/login");

    if (token && matchLogin) {
      throw redirect({ to: "/dashboard" });
    }
  },
  head: () => ({
    scripts: [{ src: `https://www.google.com/recaptcha/enterprise.js?render=${sitekey}`, defer: true }]
  })
});

const theme = createTheme({
  components: {
    TextInput: TextInput.extend({
      defaultProps: {
        variant: "filled",
        radius: "md",
        size: "md",
        withAsterisk: true
      }
    }),
    PasswordInput: PasswordInput.extend({
      defaultProps: {
        variant: "filled",
        radius: "md",
        size: "md",
        withAsterisk: true
      }
    })
  }
});

function RouteComponent() {
  const { setColorScheme } = useMantineColorScheme();
  const { windowLocationHost: host } = useWindowLocationHost();

  const { data: company } = useGetCompanyByHostQuery({ host }, { skip: !host });

  useEffect(() => {
    if (company && !document.cookie.match("userTerm")) {
      MODAL_HANDLER.acceptTerms();
    }
    setColorScheme("light");
  }, []);

  return (
    <MantineProvider theme={theme}>
      <main className="relative flex min-h-dvh justify-center bg-[#19222a]">
        <Outlet />

        <div className="absolute bottom-6 flex flex-col items-center text-gray-500">
          <p className="font-medium">Powered by</p>
          <img className="mt-2 w-44" src={logoPB} alt="" />
        </div>
      </main>
    </MantineProvider>
  );
}
